import React, { useCallback, useState } from 'react';
import { HBox, VBox } from '@cube3/cubicle/src/core/templates/layout/Flex';
import { ImageDropzone } from './ImageDropzone';
import { Button } from '@cube3/cubicle/src/core/atoms/Button';
import { Popover } from '@material-ui/core';
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography';
import { SizeVariants } from '@cube3/cubicle/src/theme/themes';
import { Divider } from '@cube3/cubicle/src/core/atoms/Divider/Divider';
import { GenericForm } from '@cube3/forms/src/forms/genericForm/GenericForm';

export const GenerationSettings = ({
  fields,
  error,
  submitDisabled,
  handleSubmit,
  onDrop,
  onDelete,
  images
}) => {
  const [open, setOpen] = useState(false);
  const [settingsAnchor, setSettingsAnchor] = useState<HTMLElement>(null);

  const toggleSettings = useCallback((e) => {
    e.stopPropagation();
    setOpen((prev) => !prev);
  }, []);

  const closeMenu = useCallback(() => setOpen(false), []);

  return (
    <>
      <HBox
        align="center"
        justify="space-between"
        gap={16}
        style={{ marginTop: 7 }}
      >
        <ImageDropzone onDelete={onDelete} onDrop={onDrop} images={images} />
        <HBox align="center" gap={16}>
          <div ref={setSettingsAnchor} style={{ transform: 'rotate(90deg)' }}>
            <Button iconLeft="more" onClick={toggleSettings} />
          </div>
          <Button
            iconLeft={error ? null : 'arrow_right'}
            label={error ? 'Retry' : ''}
            background="primary"
            buttonStyle="solid"
            roundShape={!error}
            disabled={submitDisabled}
            onClick={handleSubmit}
          />
        </HBox>
      </HBox>

      <Popover
        open={open}
        anchorEl={settingsAnchor}
        onClose={closeMenu}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <VBox gap={16} style={{ padding: '16px' }}>
          <HBox align="center">
            <Typography weight="label" variant={SizeVariants.lg}>
              Settings
            </Typography>
            <Button iconLeft="close" onClick={closeMenu} />
          </HBox>
          <Divider />
          <GenericForm
            fields={fields}
            direction="horizontal"
            weight="label"
            colorVariant="01"
            labelWidth={24}
          />
        </VBox>
      </Popover>
    </>
  );
};
